import { Report } from '@/typings/api/Report'
import { dateFormatter } from '@/helpers/dateFormatter'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const MODULE_NAME = 'lk-reports-data-collections'

export const LK_REPORT_DATA_COLLECTIONS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
} as const

export const getReportFilename = (data: Report) => {
  const createdAt = dateFormatter(data.created_at)
  const label = `${data.title} ${createdAt}.xlsx`
  return label
}

export const createDataCollectionIdModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKReportsDataCollectionsModal" */
    './components/LKReportsDataCollectionsModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

